module.exports = __webpack_public_path__ + "a173a5fabfb9f7974f5b2a78412b1f3c.png";